import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { MenuWidget } from 'src/app/models/menu-widget.model';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
@Component({
  selector: 'item-menu',
  templateUrl: './item-menu.component.html',
  styleUrls: ['./item-menu.component.scss']

})
export class ItemMenuComponent implements OnInit, AfterViewInit {

  @Input() items!: (MenuWidget | null)[] | null;
  @Input() indexMaster!: string;

  constructor(private location: Location, private router: Router) { }
  ngOnInit(): void {
    //console.log("this.indexMaster.length", this.indexMaster.length);
    const classCss = 'active';
    document.querySelectorAll('.' + classCss).forEach(el => el.classList.remove(classCss));
    let doc = document.querySelectorAll('a.list-item.medium');
    doc.forEach(el => {
      if (el.getAttribute('href')?.toLowerCase().includes(this.getFragments()[1].toLowerCase())) {
        el.classList.add(classCss);
      }
    });
  }

  ngAfterViewInit(): void {
    this.getFragments().forEach(fragment => Array.from(document.querySelectorAll('span.fragment-link')).filter(link => link.textContent?.toLowerCase() === fragment).forEach(link => (link as HTMLElement)?.click()));
  }


  getFragments(): string[] {
    return this.location.path().split("/").map(fragment => fragment.toLowerCase());
  }

}
